import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ICE_CA_ACTION_BASE_PATH } from '../../../../../../../../../features/vendor/ice/corporate-action/action/ice-ca-action-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ice-ca-action-list',
        label: 'ICE',
        to: ICE_CA_ACTION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
